module.exports = require("find-up");


//////////////////
// WEBPACK FOOTER
// external "find-up"
// module id = 35
// module chunks = 0